import { suspendComplete } from '../../actions/completions/SuspendComplete';
import { crumble as crumbleDatabase, Database } from '../../Database';
import { logError } from '../../logError';
import { crumble as crumbleReplication, Replication } from '../../Replication';
import { canReplicate, State } from '../../State';
import { Task } from '../../Task';
import { idle } from './idle';
import { notIdle } from './notIdle';

export const kind = 'Suspend';

export function suspendTask(
  replication: Replication,
  database: Database | undefined,
  pushData: boolean,
): Task {
  return {
    kind,
    start: async dispatch => {
      if (pushData) {
        replication.replicationStates.forEach(r => {
          r.reSync();
        });

        let wait = new Promise<void>(resolve =>
          setTimeout(() => {
            return resolve();
          }, 5000),
        );

        if (database) {
          wait = Promise.race([database.requestIdlePromise(), wait]);
        }
        try {
          await wait;
        } catch (error) {
          logError('Error waiting for final data push', error, {
            database: database ? crumbleDatabase(database) : 'None',
            replication: crumbleReplication(replication),
          });
        }
      }

      replication.reSyncTimeouts.forEach(timeout => {
        clearTimeout(timeout);
      });

      await Promise.all(replication.replicationStates.map(state => state.cancel()));
      dispatch(suspendComplete);
    },
  };
}

export function suspend(state: State): State {
  if (state.replication) {
    return {
      ...state,
      nextTask: suspendTask(state.replication, state.database, canReplicate(state)),
      whenIdle: notIdle(state),
    };
  }

  return idle(state);
}
